import React from 'react';
import { connect } from 'react-redux';
import { actions as uiActions } from 'ducks/ui';
import ProcessPurchaseOrdersDialogs from './ProcessPurchaseOrdersDialogs';
import { selectors as staffSelectors } from 'ducks/staff';
import { selectors as purchaseOrdersSelectors } from 'ducks/purchaseOrders/purchaseOrders';
import { IProcessPurchaseOrdersDialogsHandle, IProcessPurchaseOrdersDialogsProperties } from './ProcessPurchaseOrdersDialogs.properties';
import { Dispatch, bindActionCreators } from 'redux';

const mapStateToProps = (state) => ({
    selectedPurchaseOrder: purchaseOrdersSelectors.selectedPurchaseOrder(state) ?? (new URLSearchParams(location.search).get('PurchaseOrder') ?? ''),
    currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : ''
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
    },
    dispatch);

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(ProcessPurchaseOrdersDialogs);

export default React.forwardRef((props: Omit<IProcessPurchaseOrdersDialogsProperties, 'forwardedRef'>, ref: React.Ref<IProcessPurchaseOrdersDialogsHandle>) => (
    <ConnectedComponent {...props} forwardedRef={ref} />
));
